import type { NotificationsResponse } from '@eriko/shared-types';
import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

/** SME notification feed (backlog C2): conversations awaiting the owner's reply. */
export async function getNotifications(): Promise<NotificationsResponse> {
  const res = await apiClient.get<NotificationsResponse>(ENDPOINTS.notifications.list);
  return res.data;
}
